(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alh-header"]) return;
  try {
    
  if (!customElements.get('alh-site-header')) {
    customElements.define('alh-site-header', class extends HTMLElement {
      connectedCallback() {
        this.mobileMenu = this.querySelector('.alh-mobile-menu');
        this.mobileSearch = this.querySelector('.alh-header-search-toggle');
        this.desktopDropdowns = Array.from(this.querySelectorAll('.alh-nav-dropdown'));
        this.mobileGroups = Array.from(this.querySelectorAll('.alh-mobile-menu__group'));
        this.mobileQuery = window.matchMedia('(max-width: 989px)');

        this.setToggleLabel = (details) => {
          if (!details) return;
          const summary = details.querySelector(':scope > summary');
          if (!summary) return;
          const label = details.open ? summary.dataset.closeLabel : summary.dataset.openLabel;
          if (label) summary.setAttribute('aria-label', label);
        };

        this.syncPageLock = () => {
          const isOpen = this.mobileQuery.matches && ((this.mobileMenu && this.mobileMenu.open) || (this.mobileSearch && this.mobileSearch.open));
          document.documentElement.classList.toggle('alh-navigation-open', Boolean(isOpen));
        };

        this.handleToggle = (event) => {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement)) return;

          if (details === this.mobileMenu || details === this.mobileSearch) {
            this.setToggleLabel(details);
            if (details.open) {
              const other = details === this.mobileMenu ? this.mobileSearch : this.mobileMenu;
              if (other) other.open = false;
            } else if (details === this.mobileMenu) {
              this.mobileGroups.forEach((item) => { item.open = false; });
            }
            this.syncPageLock();
            return;
          }

          if (!details.open) return;
          if (details.classList.contains('alh-nav-dropdown')) {
            this.desktopDropdowns.forEach((item) => { if (item !== details) item.open = false; });
          }
          if (details.classList.contains('alh-mobile-menu__group')) {
            this.mobileGroups.forEach((item) => { if (item !== details) item.open = false; });
          }
        };

        this.handleDocumentClick = (event) => {
          this.desktopDropdowns.forEach((item) => {
            if (item.open && !item.contains(event.target)) item.open = false;
          });
          [this.mobileMenu, this.mobileSearch].forEach((item) => {
            if (item && item.open && !item.contains(event.target)) item.open = false;
          });
        };

        this.handleKeydown = (event) => {
          if (event.key !== 'Escape') return;
          const openItems = Array.from(this.querySelectorAll('details[open]'));
          const openItem = openItems.at(-1);
          if (!openItem) return;
          openItem.open = false;
          const summary = openItem.querySelector(':scope > summary');
          if (summary) summary.focus();
        };

        this.handleViewportChange = () => {
          if (!this.mobileQuery.matches) {
            if (this.mobileMenu) this.mobileMenu.open = false;
            if (this.mobileSearch) this.mobileSearch.open = false;
          }
          this.syncPageLock();
        };

        this.addEventListener('toggle', this.handleToggle, true);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        this.mobileQuery.addEventListener('change', this.handleViewportChange);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.handleToggle, true);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.handleViewportChange);
        document.documentElement.classList.remove('alh-navigation-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alh-homepage-revamp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alh-homepage')) {
    customElements.define('alh-homepage', class extends HTMLElement {
      connectedCallback() {
        this.setupBestseller();

        const items = Array.from(this.querySelectorAll('.alh-reveal'));
        if (!items.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('alh-is-visible'));
          return;
        }

        this.classList.add('alh--enhanced');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('alh-is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

        items.forEach((item) => this.observer.observe(item));
      }

      setupBestseller() {
        const product = this.querySelector('[data-alh-bestseller-product]');
        if (!product) return;

        const variantsNode = product.querySelector('[data-alh-bestseller-variants]');
        let variants = [];
        try {
          variants = JSON.parse(variantsNode?.textContent || '[]');
        } catch (error) {
          variants = [];
        }

        const variantInput = product.querySelector('[data-alh-bestseller-variant-id]');
        const price = product.querySelector('[data-alh-bestseller-price]');
        const comparePrice = product.querySelector('[data-alh-bestseller-compare]');
        const addButton = product.querySelector('[data-alh-bestseller-add]');
        const addText = product.querySelector('[data-alh-bestseller-add-text]');
        const mainImage = product.querySelector('.alh-bestseller__image');
        const radios = Array.from(product.querySelectorAll('[data-option-position]'));
        const currency = product.dataset.currency || 'USD';
        const addLabel = product.dataset.addLabel || 'Add to cart';
        const soldOutLabel = product.dataset.soldOutLabel || 'Sold out';

        const money = (amount) => {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount / 100);
          } catch (error) {
            return `$${(amount / 100).toFixed(2)}`;
          }
        };

        const updateVariant = () => {
          if (!variants.length || !variantInput) return;

          const selected = [];
          radios.forEach((radio) => {
            if (radio.checked) selected[Number(radio.dataset.optionPosition) - 1] = radio.value;
          });

          const variant = variants.find((candidate) => candidate.options.every((value, index) => selected[index] === value));
          if (!variant) {
            if (addButton) addButton.disabled = true;
            if (addText) addText.textContent = soldOutLabel;
            return;
          }

          variantInput.value = variant.id;
          if (price) price.textContent = money(variant.price);
          if (comparePrice) {
            const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
            comparePrice.hidden = !showCompare;
            if (showCompare) comparePrice.textContent = money(variant.compare_at_price);
          }
          if (addButton) addButton.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? addLabel : soldOutLabel;

          if (mainImage && variant.featured_image?.src) {
            mainImage.removeAttribute('srcset');
            mainImage.src = variant.featured_image.src;
            if (variant.featured_image.alt) mainImage.alt = variant.featured_image.alt;
          }
        };

        radios.forEach((radio) => radio.addEventListener('change', updateVariant));

        product.querySelectorAll('[data-alh-bestseller-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (!mainImage) return;
            mainImage.removeAttribute('srcset');
            mainImage.src = thumb.dataset.imageUrl;
            mainImage.alt = thumb.dataset.imageAlt || '';
            product.querySelectorAll('[data-alh-bestseller-thumb]').forEach((item) => {
              const active = item === thumb;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          });
        });

        const quantity = product.querySelector('[data-alh-bestseller-quantity]');
        product.querySelectorAll('[data-alh-bestseller-quantity-change]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!quantity) return;
            const next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.alhBestsellerQuantityChange || 0));
            quantity.value = next;
          });
        });

        updateVariant();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alh-list-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alh-collections-index')) {
    customElements.define('alh-collections-index', class extends HTMLElement {
      connectedCallback() {
        const items = Array.from(this.querySelectorAll('.alh-collections-reveal'));
        if (!items.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach((item) => item.classList.add('alh-collections-is-visible'));
          return;
        }

        this.classList.add('alh-collections--enhanced');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('alh-collections-is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

        items.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
